import { render, staticRenderFns } from "./StorageSelectSectionEmpty.vue?vue&type=template&id=28eb53af&scoped=true&lang=html&"
import script from "./StorageSelectSectionEmpty.vue?vue&type=script&lang=ts&"
export * from "./StorageSelectSectionEmpty.vue?vue&type=script&lang=ts&"
import style0 from "./StorageSelectSectionEmpty.vue?vue&type=style&index=0&id=28eb53af&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28eb53af",
  null
  
)

export default component.exports